_getUserEmailPreferencesById